import { useEffect, useRef } from "react";

// ----------------------- RE-RUN A LOADER EVERY N MS WHILE THE TAB IS VISIBLE ------------------------------------
export default function useAutoRefresh(load: () => void, everyMs: number, enabled = true) {
  const saved = useRef(load);
  saved.current = load;

  useEffect(() => {
    if (!enabled) return;
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") saved.current();
    }, everyMs);
    return () => clearInterval(timer);
  }, [everyMs, enabled]);
}
